const normalize = (value) => String(value ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-zA-Z0-9]/g, "")
  .toUpperCase();

const exactHeader = (headers, expected) => headers.find((header) => normalize(header) === expected) ?? "";

export function suggestUpsellerMapping(headers) {
  return {
    sku: exactHeader(headers, "SKU"),
    color: exactHeader(headers, "VARIACAO"),
    quantity: exactHeader(headers, "QTDDOPRODUTO") || exactHeader(headers, "QUANTIDADEDEPRODUTOS"),
    order: exactHeader(headers, "NDEPEDIDO") || exactHeader(headers, "NDEPEDIDODAPLATAFORMA"),
    title: exactHeader(headers, "NOMEDOANUNCIO") || exactHeader(headers, "NOMEDOPRODUTO"),
  };
}

export function isUpsellerStockDeductionRow(row) {
  const afterSale = normalize(row["Pós-venda/Cancelado/Devolvido"]);
  const orderStatus = normalize(row["Estado do Pedido"]);
  if (afterSale) return false;
  if (orderStatus === "NAOPAGO" || orderStatus === "CANCELADO") return false;
  return true;
}
